export const plans = [
  {
    title: "STARTER",
    Duration: "3-7 days",
    price: "500-1,500",
    min: "500",
    about: [
      "Min. Possible deposit: $500",
      "Max. Possible deposit: $1500",
      "$4300 Minimum return",
      "$13500 Maximum return",
      "$50 Gift Bonus",
    ],
  },
  {
    title: "PREMIUM",
    Duration: "3-7 days",
    price: "2,000-4,500",
    min: "2000",
    about: [
      "Min. Possible deposit: $2000",
      "Max. Possible deposit: $4500",
      "$17000 Minimum return",
      "$38500 Maximum return",
      "$75 Gift Bonus",
    ],
  },
  {
    title: "VIP",
    Duration: "3-7 days",
    price: "5,000-10,500",
    min: "5000",
    about: [
      "Min. Possible deposit: $5000",
      "Max. Possible deposit: $10,500",
      "$36,000 Minimum return",
      "$90,000 Maximum return",
      "$100 Gift Bonus",
    ],
  },
  {
    title: "GOLD",
    Duration: "14-28 days",
    price: "11,000-20,500",
    min: "11000",
    about: [
      "Min. Possible deposit: $11,000",
      "Max. Possible deposit: $20,500",
      "$950000 Minimum return",
      "$180000 Maximum return",
      "$200 Gift Bonus",
    ],
  },
  {
    title: "DIAMOND",
    Duration: "14-28 days",
    price: "21,000-99,000",
    min: "21000",
    about: [
      "Min. Possible deposit: $21000",
      "Max. Possible deposit: $99000",
      "$195000 Minimum return",
      "$750000 Maximum return",
      "$250 Gift Bonus",
    ],
  },
];
